import {useState} from "react";

let reportRerenderBeforeRefactorCounter = 0;
let messageRerenderBeforeRefactorCounter = 0;

let reportRerenderAfterRefactorCounter = 0;
let messageRerenderAfterRefactorCounter = 0;

const ReportComponent = () => {
  const [reportCount, setReportCount] = useState(0);
  reportRerenderAfterRefactorCounter++;

  return (
    <>
      <h3>
        Report component
      </h3>
      Report component rerenders: {reportRerenderAfterRefactorCounter}
      <br />
      <button onClick={() => setReportCount(state => state + 1)}>
        Send "report" :) Report count: {reportCount}
      </button>
    </>
  )
}

const MessageComponent = () => {
  const [message, setMessage] = useState('');
  messageRerenderAfterRefactorCounter++;

  return (
    <>
      <h3>
        Form component
      </h3>
      <form onSubmit={e => {
        e.preventDefault();
        setMessage('');
        alert(`Sent message: ${message}`);
      }}>
        Message component rerender: {messageRerenderAfterRefactorCounter}
        <br />
        <input value={message} onChange={e => setMessage(e.target.value)}/>
        <br />
        <button type="submit">
          Send message
        </button>
      </form>
    </>
  );
}

export const BeforeRefactorApp = () => {
  const [reportCount, setReportCount] = useState(0);
  const [message, setMessage] = useState('');

  reportRerenderBeforeRefactorCounter++;
  messageRerenderBeforeRefactorCounter++;

  return (
    <>
      <h2>
        Version before refactor
      </h2>
      <>
        <h3>
          Report component
        </h3>
        Report component rerenders: {reportRerenderBeforeRefactorCounter}
        <br />
        <button onClick={() => setReportCount(state => state + 1)}>
          Send "report" :) Report count: {reportCount}
        </button>
      </>
      <>
        <h3>
          Form component
        </h3>
        <form onSubmit={e => {
          e.preventDefault();
          setMessage('');
          alert(`Sent message: ${message}`);
        }}>
          Message component rerender: {messageRerenderBeforeRefactorCounter}
          <br />
          <input value={message} onChange={e => setMessage(e.target.value)}/>
          <br />
          <button type="submit">
            Send message
          </button>
        </form>
      </>
    </>
  );
}

export const AfterRefactorApp = () => {
  return (
    <>
      <h2>Version after refactor</h2>
      <ReportComponent />
      <MessageComponent />
    </>
  )
}
